import React, { useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { Context } from '../context'
import ServiceAuth from '../services/service_auth'
import ServiceQuery from '../services/service_query'
import { Link } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav';
import { Navigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import { AuthContext } from '../Context/authProvider'

function AccueilClient () {


  // const user = ServiceAuth.getCurrentUser()
  const [queryError, setQueryError] = useState("")
  const [querySuccess, setQuerySuccess] = useState("")
  const [sharedStatus, setSharedStatus] = useState("")
  const {auth, authDispatch} = useContext(AuthContext)

  async function handleButtonOnClickDocs(event){        
    let returnObject
    let sharedLink
    var result = window.confirm("Voulez-vous accéder au documents technique ?");
    if (result === true){
      returnObject = await ServiceQuery.getSharedDocs(auth.catTarif)
      setSharedStatus(returnObject[0])
      sharedLink = returnObject[1]
      if(returnObject[1] !== null && returnObject[1] !== ''){
        const newWindow = window.open(returnObject[1], '_blank', 'noopener,noreferrer')
      }
      if(returnObject !== null){
      }else{
      }
    }
  }
  const handleSubmit = async (event) =>{
    event.preventDefault();
    // console.log('value',event.target[0].value)
    let emailValue = event.target[0].value
    try {
      if(emailValue !== auth?.mail){
        var returnService = await ServiceQuery.postNewEmail(emailValue)
        authDispatch({type:'updateEmail', payload: {emailValue}})
        setQuerySuccess(returnService)
      }      
    } catch (error) {
        setQueryError(error)
    }
  }
  
  return (
      <div className="list-group">
          {/* <div className="alert alert-info">
            Le processus de commande évolue, allez dans l'onglet "Mes Paniers" pour passer commande. Découvrez le fonctionnement à l'aide du guide ci-dessous :<br/> 
            <b><a href={process.env.PUBLIC_URL + "/Guide_Paniers_v2.pdf"} target="_blank" rel='noreferrer noopener'>Guide Paniers</a></b>
          </div> */}
          <div className="alert alert-secondary" style={{fontSize: '1.1em'}}>
            Du 15 septembre au 15 octobre, profitez de notre offre promotionnelle sur les rentoilages en toile Orchestra en ajoutant le code <b>"PROMO RENTRÉE"</b> dans vos commandes par mail<br/> ou <u>dans le champ dédié</u> dans le bon de commande sur l'espace pro<br/> 
            Retrouvez les détails de l'offre ici : <b><a href={process.env.PUBLIC_URL + "/SocotexPromoRentree.jpg"} target="_blank" rel='noreferrer noopener'>PROMO RENTRÉE</a></b>
          </div>
          {/* <div className='actuAccueilClient'>
            <a href={process.env.PUBLIC_URL + '/BDC offre spéciale tente pour Pro.pdf'} target="_blank" rel='noreferrer noopener'>
              <img src={process.env.PUBLIC_URL + '/OPtente3x3.jpg'} >
              </img>
            </a>
          </div> */}
        {sharedStatus &&<div className="alert alert-info mx-5 mb-0" style={{ marginTop: '1em' }}> <b style={{ fontSize: '1.1em'}}>{sharedStatus}</b></div>}
        <h1 className="text-center mt-2">Espace Pro</h1>
        { <h3 className="text-center mt-2"><button style={{ paddingLeft: '1.5em', paddingRight: '1.5em' }} className="btn btn-primary" disabled={''} onClick={handleButtonOnClickDocs}><b>Accès aux documents techniques</b></button></h3> }
          <h3 className="text-center mt-2"><Link as={Link} to="/ContenuSupp" style={{color:"white"}}><button className="btn btn-primary" disabled={''} onClick={null}><b>Banque d'images</b></button></Link></h3>
          <div className='row'>
          <div className='col'>
            <form id="formAccountDetails" onSubmit={handleSubmit}>
              <h3 className=''>Détail du compte</h3>

              <ul className="list-group list-group-flush">
                <li className="list-group-item"> Société: {auth?.businessName}</li>
                <li className="list-group-item"> Code client: {auth?.numSage}</li>
                <li className="list-group-item"> Identifiant: {auth?.name}</li>
                <li className="list-group-item"> Nom complet: {auth?.fullName}</li>
                <li className="list-group-item">
                  Email: <input type="email" id="email" defaultValue={auth?.mail} required />
                </li>
                {/* <li className="list-group-item"> role: {auth?.role}</li> */}

                <li className="list-group-item">
                  <button type="submit" style={{ paddingLeft: '1.5em', paddingRight: '1.5em' }} className="btn btn-primary" disabled={''}>Sauvegarder les modifications</button>
                </li>
                <li className="list-group-item">{querySuccess && <div className="alert alert-info">{querySuccess}</div>}</li>
                <li className="list-group-item">{queryError && <div className="alert alert-danger">{queryError}</div>}</li>
              </ul>
            </form>
          </div>
          <div className='col'>
            <h3 className=''>Représentant du compte</h3>
            <ul className="list-group list-group-flush" style={{ alignItems: "center" }}>
              <img src={process.env.PUBLIC_URL + '/image_responsable/' + auth?.ownerId + '.jpg'} alt="photo_responsable" width="200px" height="160px" className="d-inline-block align-text-top mt-1" />
              <li className="list-group-item"> nom: {auth?.ownerName}</li>
              <li className="list-group-item"> Titre: {auth?.ownerTitle}</li>
              <li className="list-group-item"> email: {auth?.ownerMail}</li>
              <li className="list-group-item"> téléphone: {auth?.ownerPhone}</li>
            </ul>
          </div>
        </div>
          <div className="alert alert-secondary mx-5 mb-0" style={{}}>Pour toute question ou problème lié à l'espace pro, contactez-nous à
            <a href='mailto:flux@socotex.fr' style={{'color':'#6756DA'}}> <u>SUPPORT</u> </a><br/>
            en joignant si possible une description et des captures d'écran.
          </div>
      </div>
  )
}

export default AccueilClient